/** Declaración de rutas con lazy imports (chunks por área). */
import PosView from '@/views/pos/PosView.vue';
import CobrosView from '@/views/dashboard/CobrosView.vue';
import DashboardHomeView from '@/views/dashboard/DashboardHomeView.vue';

export default [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "public" */ '@/views/public/LandingView.vue'),
    },
    {
        path: '/u/modulo-no-incluido',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ModuleNotIncludedView.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/u/publicaciones',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/PublicationsListView.vue'),
        meta: { requiresAuth: true, features: ['publicaciones'] },
    },
    {
        path: '/u/pedidos',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/OrdersView.vue'),
        meta: { requiresAuth: true, featuresAny: ['carrito_online', 'pedido_mostrador', 'mesas'] },
    },
    {
        path: '/u/cobros',
        component: CobrosView,
        meta: { requiresAuth: true, features: ['pos'] },
    },
    {
        path: '/u/comprobantes-arca',
        component: () =>
            import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ComprobantesArcaView.vue'),
        meta: { requiresAuth: true, roles: ['negocio'], features: ['integracion_arca'] },
    },
    {
        path: '/u/analiticas',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/AnaliticasView.vue'),
        meta: { requiresAuth: true, roles: ['negocio'], features: ['analiticas'] },
    },
    {
        path: '/u/caja',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/CajaActualView.vue'),
        meta: { requiresAuth: true, roles: ['negocio', 'vendedor'], features: ['caja'] },
    },
    {
        path: '/u/cajas',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/CajaHistorialView.vue'),
        meta: { requiresAuth: true, roles: ['negocio'], features: ['caja'] },
    },
    {
        path: '/u/cajas/:id',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/CajaDetalleView.vue'),
        meta: { requiresAuth: true, roles: ['negocio', 'vendedor'], features: ['caja'] },
    },
    {
        path: '/u/clientes',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ClientesView.vue'),
        meta: { requiresAuth: true, features: ['clientes'] },
    },
    {
        path: '/u/pedido-mostrador',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ManualOrderView.vue'),
        meta: { requiresAuth: true, features: ['pedido_mostrador'] },
    },
    {
        path: '/u/pos',
        component: PosView,
        meta: { requiresAuth: true, roles: ['negocio', 'vendedor'], features: ['pos'] },
    },
    {
        path: '/u/mesas/:mesaId?',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/MesasView.vue'),
        meta: { requiresAuth: true, roles: ['negocio', 'vendedor'], features: ['mesas'] },
    },
    {
        path: '/u/dispositivos',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/DevicesView.vue'),
        meta: { requiresAuth: true, roles: ['negocio'], features: ['pos'] },
    },
    {
        path: '/u/vendedores',
        redirect: { path: '/u/modificar', query: { seccion: 'equipo' } },
        meta: { requiresAuth: true, roles: ['negocio'], features: ['vendedores'] },
    },
    {
        path: '/u/ticket',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/TicketConfigView.vue'),
        meta: { requiresAuth: true, roles: ['negocio'], features: ['tickets'] },
    },
    {
        path: '/u/etiquetas',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/EtiquetasGondolaView.vue'),
        meta: { requiresAuth: true, roles: ['negocio', 'admin'], features: ['pos'] },
    },
    {
        path: '/u/logs',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/LogsView.vue'),
        meta: { requiresAuth: true, roles: ['negocio', 'admin'] },
    },
    {
        path: '/u/stock',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/StockView.vue'),
        meta: { requiresAuth: true, features: ['stock'] },
    },
    {
        path: '/u/nuevapublicacion',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/PublicationNewView.vue'),
        meta: { requiresAuth: true, features: ['publicaciones'] },
    },
    {
        path: '/u/home',
        component: DashboardHomeView,
        meta: { requiresAuth: true },
    },
    {
        path: '/u/crearqr',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/QrGeneratorView.vue'),
        meta: { requiresAuth: true, features: ['menu_online'] },
    },
    {
        path: '/u/login',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/LoginView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/verificar-email',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/VerifyEmailView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/recuperar-contrasena',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ForgotPasswordView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/restablecer-contrasena',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/ResetPasswordView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/registrar',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/RegisterView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/planes',
        component: () => import(/* webpackChunkName: "plans" */ '@/views/plans/PlansView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/registrar/return',
        component: () => import(/* webpackChunkName: "auth" */ '@/views/auth/PaymentSuccessView.vue'),
        meta: { requiresAuth: false, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/negocios',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminBusinessesView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/negocios/nuevo',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminCrearNegocioView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/negocios/:usuario',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminNegocioDetalleView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/pagos',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminPagosSuscripcionView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/herramientas',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/AdminToolsView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/vendedores',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/dashboard/VendedoresView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/ticket',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/dashboard/TicketConfigView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/etiquetas',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/dashboard/EtiquetasGondolaView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/admin/dispositivos',
        component: () => import(/* webpackChunkName: "admin" */ '@/views/dashboard/DevicesView.vue'),
        meta: { requiresAuth: true, roles: ['admin'] },
    },
    {
        path: '/u/modificar',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ProfileEditView.vue'),
        meta: { requiresAuth: true, allowWhenPlanSuspended: true },
    },
    {
        path: '/u/nuevoProducto',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ProductNewView.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/u/productos',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ProductsListView.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/pedido/:token',
        component: () =>
            import(/* webpackChunkName: "store" */ '@/components/SeguimientoPedidoComponent.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/:nombreNegocio',
        component: () => import(/* webpackChunkName: "store" */ '@/components/NegocioComponent.vue'),
        meta: { requiresAuth: false },
    },
];
